import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from './Icon';
export function getResultMessage(t, isDashboard, commitStatusResult, commitHasThreshold, iconText, iconTextThresholds) {
    let message = '';
    message = isDashboard ? t('latestCommit') : t('commit');
    message = `${message} ${t('endedUpAs')}`;
    message = `${message} ${t(commitStatusResult ? 'successful' : 'failed')}.`;
    message = `${message} ${t('commit')}${commitHasThreshold ? ` ${t(iconTextThresholds)} repository thresholds and` : ''}`;
    message = `${message} ${t('analyzeFinished')} ${t(iconText)}.`;
    return message;
}
export function isCommitSucceeded(commitHasThreshold, thresholdResult, isCommitSuccess) {
    return commitHasThreshold ? thresholdResult && isCommitSuccess : isCommitSuccess;
}
export function getCommitStatusMessage(t, isCommitDone, isCommitMeetingThreshold, commitHasThreshold, isCommitTimedOut, isDashboard) {
    const isCommitSuccess = isCommitDone && isCommitMeetingThreshold;
    const thresholdResult = commitHasThreshold && isCommitMeetingThreshold;
    const iconText = isCommitSuccess ? 'successful' : 'failed';
    const iconTextThresholds = thresholdResult ? 'passed' : 'crossed';
    const isCommitSuccessful = isCommitSucceeded(commitHasThreshold, thresholdResult, isCommitSuccess);
    const resultMessage = getResultMessage(t, !!isDashboard, isCommitSuccessful, commitHasThreshold, iconText, iconTextThresholds);
    const iconName = isCommitTimedOut ? 'exclamation' : isCommitSuccessful ? 'check' : 'times';
    const iconColor = !isCommitSuccessful || isCommitTimedOut ? 'danger' : 'success';
    return {
        message: isCommitTimedOut ? `${t('latestCommit')} ${t('failed')}` : resultMessage,
        iconName,
        iconColor,
    };
}
class CommitStatusIcon extends Component {
    render() {
        const { isCommitDone, className, isDashboard, commitOptions, isCommitTimedOut, isCommitMeetingThreshold, t } = this.props;
        const { message, iconName, iconColor, } = getCommitStatusMessage(t, isCommitDone, isCommitMeetingThreshold, !!commitOptions?.thresholds, isCommitTimedOut, !!isDashboard);
        return _jsx(Icon, { name: iconName, className: clsx(`text-${iconColor}`, className), title: message });
    }
}
CommitStatusIcon.defaultProps = {
    className: '',
    isDashboard: false,
};
export default withTranslation()(CommitStatusIcon);
